module.exports = __webpack_public_path__ + "img/wupin.a88ed8ab.png";